import {Button, closeCurrentDialog} from 'platform/components';
import {Box, Right, VStack} from 'platform/foundation';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish, useNavigate} from 'shared/web';

import type {LinkClickOverride, QueryFilterObject, RowData} from 'features/eag-grid';

import {DmsDataGrid} from '../../DmsDataGrid/DmsDataGrid';

interface OdometerHistoryProps {
  vehicleId: string | Nullish;
}

export function OdometerHistory(props: OdometerHistoryProps) {
  const navigate = useNavigate();
  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {vehicleId: props.vehicleId}]);

  const linkClickOverride: LinkClickOverride = (overrideProps) => {
    const isBusinessCase = hasCorrectResourceId(overrideProps.rowData, 'BUSINESS_CASE');
    const isServiceCase = hasCorrectResourceId(overrideProps.rowData, 'SERVICE_CASE');

    if (isBusinessCase) {
      const testDrivePath = overrideProps.defaultRedirectRoute.replace('/overview', '/test-drive');
      navigate(testDrivePath);
      return;
    }

    if (isServiceCase) {
      navigate(`${overrideProps.defaultRedirectRoute}?section=checkinHandover`);
      return;
    }

    navigate(overrideProps.defaultRedirectRoute);
  };

  return (
    <VStack spacing={4}>
      <Box height={100}>
        <DmsDataGrid
          gridCode="odometer"
          data-testid="odometer"
          queryModifier={queryModifier}
          _useAsLastResort_linkClickOverride={linkClickOverride}
        />
      </Box>

      <Right>
        <Button
          variant="secondary"
          onClick={closeCurrentDialog}
          title={i18n.t('general.actions.close')}
        />
      </Right>
    </VStack>
  );
}

type TypedResourceRowData<T extends string> = RowData & {record: {value: {resourceId: T}}};

function hasCorrectResourceId<T extends string>(
  rowData: RowData,
  resourceId: T
): rowData is TypedResourceRowData<T> {
  return (rowData as TypedResourceRowData<string>).record?.value?.resourceId === resourceId;
}
